import { FileDocumentEditOutlineIcon } from './FileDocumentEditOutlineIcon';

/**
 * author: Michael Irigoyen
 * id E33F3608-CA6A-4BC3-BA3B-16AC369F10FD
 * name file-document-edit-outline
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-document-edit-outline.svg
 * tags
 * - Edit / Modify 
 * - Files / Folders 
 */
export const ContractOutlineIcon = FileDocumentEditOutlineIcon;
export default ContractOutlineIcon